import { PrimaryButton } from '@/components/common/PrimaryButton';
import cookiesConstants from '@/constants/cookies.constants';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { OnBoardingModalStepTwoProps } from '@/types/props/components/modals';
import { ModalsEnum } from '@/types/translations/ModalsEnum';
import { setCookie } from 'cookies-next';
import { useRouter } from 'next/router';

export default function OnBoardingModalStepTwo({
  handleSkipAndFinish,
}: OnBoardingModalStepTwoProps) {
  const { locale = 'en', pathname, push } = useRouter();
  const { translate } = useTypedTranslation<ModalsEnum>('modals');

  return (
    <>
      <p className="tw-font-plusJakartaSans tw-text-3xl tw-font-bold tw-leading-[40.32px] tw-text-white max-nine:tw-mx-auto max-nine:tw-text-center max-nine:tw-text-xl">
        {translate(ModalsEnum['onboarding_modal.get_the_best_out_of_spiritory'])}
      </p>
      <p className="tw-font-plusJakartaSans tw-text-2xl tw-font-medium tw-leading-[33.6px] tw-text-white max-nine:tw-mx-auto max-nine:tw-text-center max-nine:!tw-text-lg">
        {translate(ModalsEnum['onboarding_modal.would_you_like_to_buy_or_sell_whisky_or_spirits'])}
      </p>
      <div className="tw-mt-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-pb-16 child:tw-w-full child:nine:tw-max-w-[unset]">
        <PrimaryButton
          white={true}
          onClick={async () => {
            setCookie(
              cookiesConstants.COOKIES.RETURN_AFTER_ONBOARDING.name,
              pathname,
              cookiesConstants.COOKIES.RETURN_AFTER_ONBOARDING.options
            );
            handleSkipAndFinish();
            await push(`/${locale}/auth/onboarding/buyer/start`);
          }}
        >
          {translate(ModalsEnum['onboarding_modal.create_a_buyer_account'])}
        </PrimaryButton>
        <PrimaryButton
          white={true}
          onClick={async () => {
            setCookie(
              cookiesConstants.COOKIES.RETURN_AFTER_ONBOARDING.name,
              pathname,
              cookiesConstants.COOKIES.RETURN_AFTER_ONBOARDING.options
            );
            handleSkipAndFinish();
            await push(`/${locale}/auth/onboarding/seller/start`);
          }}
        >
          {translate(ModalsEnum['onboarding_modal.create_a_seller_account'])}
        </PrimaryButton>
        <PrimaryButton outlined={true} white={true} onClick={handleSkipAndFinish}>
          {translate(ModalsEnum['onboarding_modal.i_just_want_to_explore_for_now'])}
        </PrimaryButton>
      </div>
    </>
  );
}
